export default __webpack_public_path__ + "static/media/467.eb5619c9.jpg";